import styled from 'styled-components';

export const RazitkoWrap = styled.div`
  width: 100%;
  height: 25vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5vh;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const RazitkoImage = styled.img`
  height: 100%;
`;

export const ButtonsWrap = styled.div`
  display: flex;
`;

export const ButtonsItem = styled.div`
  width: 50%;
  align-self: flex-end;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const RazitkoItem = styled.div`
  width: 50%;
  width: 100%;
  height: 25vh;
  display: flex;
  justify-content: center;
  align-content: center;
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;
